import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    videoTemplate,
    videoInSliderTemplate,
    videoInTabsTemplate,
    multipleVideosTemplate,
    multipleVideosAutoplayTemplate,
} from "./video.templates";

export default {
    title: "Website/Partial Templates/Video",
    render: videoTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};

export const VideoInSlider = {
    render: videoInSliderTemplate.bind({}),
};

export const VideoInTabs = {
    render: videoInTabsTemplate.bind({}),
};

export const MultipleVideos = {
    render: multipleVideosTemplate.bind({}),
};

export const MultipleVideosAutoplay = {
    render: multipleVideosAutoplayTemplate.bind({}),
};
